import {
	OPERAND_TYPE_LIST,
	type Jast,
	type OperatorValue,
	type TerminalClause,
	creators,
	print,
} from '@atlaskit/jql-ast';
import { isListOperand } from '../is-list-operand/index.tsx';
import { resolveOperator } from './resolve-operator.tsx';

export const changeOperator = (
	ast: Jast,
	clause: TerminalClause,
	operatorValue: OperatorValue,
): string => {
	let correctOperator = operatorValue;

	if (clause.operand) {
		correctOperator = resolveOperator({
			operatorValue,
			isList: isListOperand(clause.operand),
		});

		if (clause.operand.operandType === OPERAND_TYPE_LIST && clause.operand.values.length === 1) {
			clause.setOperand(clause.operand.values[0]);
		}
	}

	clause.setOperator(creators.operator(correctOperator));

	return print(ast, {
		operatorCase: 'upper',
	});
};
